<template>
  <div
    :class="listContainerClass"
    class="d-flex justify-content-md-end text-left list-icons-container separator separator-icons"
  >
    <div class="d-flex flex-column justify-content-center first-icon-column">
      <span>
        <span :class="['status-icon', 'mx-1', 'text-success']" :title="$t('Valid')">
          <font-awesome-icon :icon="'circle'" />
        </span> {{ $t('Valid') }}
      </span>
      <span>
        <span :class="['status-icon', 'mx-1', 'text-danger']" :title="$t('Invalid')">
          <font-awesome-icon :icon="'times-circle'" />
        </span> {{ $t('Invalid') }}
      </span>
    </div>
    <div class="ml-3 d-flex flex-column justify-content-center">
      <div class="d-flex flex-column justify-content-center">
        <span>
          <span :class="['status-icon', 'mx-1', 'text-danger']" :title="$t('Reported')">
            <font-awesome-icon :icon="'circle'" />
          </span> {{ $t('Reported') }}
        </span>
        <span>
          <span :class="['status-icon', 'mx-1', 'text-warning']" :title="$t('Appealed')">
            <font-awesome-icon :icon="'circle'" />
          </span> {{ $t('Appealed') }}
        </span>
      </div>
    </div>
    <div class="ml-3 d-flex flex-column justify-content-center">
      <span>
        <span :class="['status-icon', 'mx-1', 'text-success']" :title="$t('Report accepted')">
          <font-awesome-icon :icon="'thumbs-up'" />
        </span> {{ $t('Report accepted') }}
      </span>
      <span>
        <span :class="['status-icon', 'mx-1', 'text-danger']" :title="$t('Report rejected')">
          <font-awesome-icon :icon="'thumbs-down'" />
        </span> {{ $t('Report rejected') }}
      </span>
    </div>
    <div class="ml-3 d-flex flex-column justify-content-center">
      <span>
        <span :class="['status-icon', 'mx-1', 'text-warning']" :title="$t('Time Extended')">
          <font-awesome-icon :icon="'hourglass-half'" />
        </span> {{ $t('Time Extended') }}
      </span>
      <span>
        <span :class="['status-icon', 'mx-1', 'text-info']" :title="$t('Archived')">
          <font-awesome-icon :icon="'archive'" />
        </span> {{ $t('Archived') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyLeadsStatusIcons',
  props: {
    listContainerClass: {
      type: String,
      default: 'mr-3',
    },
  }
}
</script>
<style scoped lang="scss">
  @include media-breakpoint-down(sm) {
    .first-icon-column {
      margin-left: 1rem;
    }
  }
</style>
